import { render, staticRenderFns } from "./GraphDetail67.vue?vue&type=template&id=be090e2a&scoped=true"
import script from "./GraphDetail67.vue?vue&type=script&lang=js"
export * from "./GraphDetail67.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be090e2a",
  null
  
)

export default component.exports